module.exports = __webpack_public_path__ + "img/pres_1.acaddb84.png";